import {useContext} from 'react';

import PaymentContext from '../../contexts/PaymentContext';

const usePayment = () => {
  return useContext(PaymentContext);
};

export default usePayment;
